import React, { useState } from 'react'
import { DragDropUploadPropsTypes } from './InputGroupType'
import { CloseIcon } from '../iconSet/IconSet'

const DragDropUpload = (props: DragDropUploadPropsTypes) => {

    
    const [isDragging, setIsDragging] = useState<boolean>(false)

    const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault()
        e.stopPropagation()
        setIsDragging(true)
    }

    const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault()
        e.stopPropagation()
        setIsDragging(false)
    }
    
    const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault()
        e.stopPropagation()
        setIsDragging(false)
    
        if (e.dataTransfer.files) {
            const droppedFiles = Array.from(e.dataTransfer.files)
            props.setFile((prevFiles) => [...prevFiles, ...droppedFiles])
        }
    }

    const handleFileInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            const selectedFiles = Array.from(e.target.files)
            props.setFile((prevFiles) => [...prevFiles, ...selectedFiles])
        }
    };

    const handleCloseFile = (fileName: string) => {
        props.setFile([])
    }

    return (
        <div className={`drag-drop-upload-wrapper`}>
            <span>{props.label}</span>
            <div className={`drag-drop-upload`} onDragOver={handleDragOver} onDragEnter={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} style={{backgroundColor: isDragging ? 'rgba(var(--color-main-black) 0.5)' : 'var(--color-container-drag-bg)'}}>
            <p>Drag and drop files here, or click to select files</p>
            <input type="file" multiple onChange={handleFileInput} id="fileInput"/>
            <label htmlFor="fileInput">Browse Files</label>

            {props.files.length > 0 && (
                <div className={`upload-file-wrapper`}>
                    <span>{props.files[0].name} <div onClick={(e) => handleCloseFile(props.files[0].name)}><CloseIcon width='1rem' color='var(--color-main-red)'/></div></span>
                </div>
            )}
        </div>
    </div>
    )
}

export default DragDropUpload